import { extract } from '../extractors/unlock';
import { fmtUSD, fmtPct } from '../extractors/_shared';

export function buildPromptBlock(project, a) {
  const d = extract(project, a);
  if (!d) return '';
  const lines = ['【代币解锁日程（Surf tokenomics）】'];
  if (d.next30dAmount != null) lines.push(`未来30日解锁量: ${fmtUSD(d.next30dAmount)}${d.next30dRatio != null ? ` （${fmtPct(d.next30dRatio, 2)} 流通）` : ''}`);
  if (d.next180dAmount > 0)    lines.push(`未来180日累计: ${fmtUSD(d.next180dAmount)}${d.next180dRatio != null ? ` （${fmtPct(d.next180dRatio, 2)} 流通）` : ''}`);
  lines.push(`未来90日解锁事件数: ${d.eventsNext90dCount}`);
  if (d.teamShare != null) lines.push(`团队/投资方累计占比: ${fmtPct(d.teamShare, 0)}`);
  if (d.allocations.length) {
    const top5 = [...d.allocations].sort((a, b) => (b?.amount || 0) - (a?.amount || 0)).slice(0, 5);
    lines.push(`分配类别 Top 5: ${top5.map(a => `${a?.name}=${fmtUSD(a?.amount)}`).join(', ')}`);
  }
  if (d.events.length) {
    const upcoming = d.events.slice(0, 3).map(e => `${e?.date}(${fmtUSD(e?.totalAmount)})`);
    lines.push(`最近 3 个解锁事件: ${upcoming.join('; ')}`);
  }
  return lines.join('\n');
}
